import 'leaflet';
import { GestureHandling } from '@raruto/leaflet-gesture-handling';

function getLeafletLat($leaflet) {
  return Number($leaflet.attr('data-lat')) || 48.4182;
}

function getLeafletLng($leaflet) {
  return Number($leaflet.attr('data-lng')) || -123.37781;
}

function getLeafletCenter($leaflet) {
  return [getLeafletLat($leaflet), getLeafletLng($leaflet)];
}

function getLeafletZoom($leaflet) {
  return Number($leaflet.attr('data-zoom')) || 14;
}

function getMarkerLat($leafletMarker) {
  return Number($leafletMarker.attr('data-lat'));
}

function getMarkerLng($leafletMarker) {
  return Number($leafletMarker.attr('data-lng'));
}

function getMarkerIcon($leafletMarker) {
  if ($leafletMarker.attr('data-icon') === 'oswego') {
    return L.divIcon({
      html: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 215.1 221.8"><path d="M215.1 148.7c-15.5 42.6-56.3 73.1-104.3 73.1C49.6 221.8 0 172.1 0 110.9S49.6 0 110.9 0c2.9 0 5.7.1 8.5.4h-1.9C58.9.4 11.2 48.1 11.2 106.7S58.9 213 117.5 213c43.7-.1 81.3-26.6 97.6-64.3M40 67.1c14.7-23.9 41.1-39.8 71.2-39.8 46.2 0 83.6 37.4 83.6 83.6 0 41.2-29.9 75.5-69.1 82.4 44.1-4.2 78.8-41.4 78.8-86.6 0-48-39.1-87.1-87.1-87.1-33.6 0-62.9 19.3-77.4 47.5"/></svg>`,
      className: 'leaflet-marker-oswego',
      iconSize: [46, 46],
      iconAnchor: [23, 23],
    });
  }
  return L.divIcon({
    html: `<svg xmlns="http://www.w3.org/2000/svg"><path d="M10 0c5.523 0 10 4.477 10 9.999C20 15.523 15.523 20 10 20S0 15.523 0 9.999C0 4.477 4.477 0 10 0Z"/></svg>`,
    className: 'leaflet-marker-default',
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });
}

function getLeafletMarker($leafletMarker) {
  const marker = L.marker(
    [getMarkerLat($leafletMarker), getMarkerLng($leafletMarker)],
    { icon: getMarkerIcon($leafletMarker) }
  );

  if ($leafletMarker.html()) {
    marker.bindPopup($leafletMarker.html(), {
      offset: L.point(0, -10),
    });
  }

  return marker;
}

$('.js-leaflet').each((index, element) => {
  const $leaflet = $(element);
  const $leafletMarkers = $leaflet.find('.js-leaflet-marker');

  L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

  const map = L.map(element, {
    center: getLeafletCenter($leaflet),
    zoom: getLeafletZoom($leaflet),
    gestureHandling: true,
  });

  L.TileLayer.Custom = L.TileLayer.extend({
    createTile: function (coords, done) {
      const tile = L.TileLayer.prototype.createTile.call(this, coords, done);
      const container = document.createElement('div');
      container.appendChild(tile);
      return container;
    },
  });

  L.tileLayer.custom = function () {
    return new L.TileLayer.Custom(...arguments);
  };

  L.tileLayer
    .custom('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      minZoom: 1,
      maxZoom: 19,
      attribution:
        '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    })
    .addTo(map);

  const markers = L.featureGroup();

  const triggers = [];

  $leafletMarkers.each((index, element) => {
    const $leafletMarker = $(element);

    const marker = getLeafletMarker($leafletMarker);

    const markerTrigger = $leafletMarker.attr('data-trigger');
    if (markerTrigger) {
      triggers.push([$(markerTrigger), marker]);
    }

    markers.addLayer(marker);
  });

  markers.addTo(map);

  map.fitBounds(markers.getBounds());

  if (map.getZoom() > 17) {
    map.setZoom(17);
  }

  $(window).on('scroll', function () {
    const middleOfScreen = $(window).scrollTop() + $(window).height() / 2;
    triggers.forEach(([trigger, marker]) => {
      const triggerTop = trigger.offset().top;
      const triggerBottom = triggerTop + trigger.height();
      if (triggerTop < middleOfScreen && triggerBottom > middleOfScreen) {
        marker.openPopup();
        L.DomUtil.addClass(marker._icon, 'leaflet-marker-active');
      } else {
        marker.closePopup();
        L.DomUtil.removeClass(marker._icon, 'leaflet-marker-active');
      }
    });
  });
});
